var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 10,
    fill: "#EEEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7465 42.5937L48.8528 37.729C48.4668 35.6279 48.2737 34.5773 47.5093 33.9553C46.7449 33.3333 45.6469 33.3333 43.4509 33.3333H37.5491C35.3531 33.3333 34.255 33.3333 33.4906 33.9553C32.7262 34.5773 32.5332 35.6279 32.1472 37.729L31.2534 42.5937C30.4521 46.9549 30.0515 49.1355 31.2852 50.5678C32.5189 51.9999 34.7981 51.9999 39.3564 51.9999H41.6436C46.202 51.9999 48.4811 51.9999 49.7148 50.5678C50.9485 49.1355 50.5479 46.9549 49.7465 42.5937Z",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4974 38V46.6667M37.1641 44L40.4974 47.3333L43.8307 44",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4974 38.6667C52.7065 38.5612 52.8882 38.4283 53.0497 38.2607C53.8307 37.45 53.8307 36.1452 53.8307 33.5357C53.8307 30.9261 53.8307 29.6214 53.0497 28.8107C52.2686 28 51.0115 28 48.4974 28H32.4974C29.9832 28 28.7262 28 27.9451 28.8107C27.1641 29.6214 27.1641 30.9261 27.1641 33.5357C27.1641 36.1452 27.1641 37.45 27.9451 38.2607C28.1066 38.4283 28.2884 38.5612 28.4974 38.6667",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.6de6749ba0a7bf955e4235ed13b82ebb.svg";
export { ForwardRef as ReactComponent };